module.exports = __webpack_public_path__ + "static/media/drill-day-1.e15fa588.png";